import React from 'react'
import Klima_Furthur from '../../../component/virtualstart/furthur_pages/klimaFurthur/index';

export function KlimaFurthur() {
  return (
    <Klima_Furthur />
  )
}
